export enum LanguageActionType {
    CHANGE_VALUE_LANGUAGE = 'CHANGE_VALUE_LANGUAGE'
}
export interface LanguageState {
    languageState: string
}
export interface LanguageAction {
    type: string,
    payload: string
}